<div class="signpost-body">
  <img src="/assets/Nessy-Logo-R-white.png" class="nessyLogoR" alt="Nessy Logo"/>
  <ng-container>
    @if (isAllowed() || (authService.isAuthenticated$ | async)) {
    <router-outlet></router-outlet>
    } @else {
    <app-spinner></app-spinner>
    }
  </ng-container>
</div>